export const environment = {
  production: true,
  selectedProduct: null,
  protocol: "",
  overlay: false,
  isCompany: false,
  TYPE_PRODUCT: 0, // 0 - todos, 1 - CPF, 2 - CNPJ
  COMERCIAL_SITE_ID: 2,
  formPayment: null,
  PRODUCT_SITE: 5,
  PRODUCT_SITE_SAFEID: 1,
  EMISSION_TYPE: 3,
  STEP_NUMBER: 0,

  CONFIG_MANAGER: {
    url: "https://configmanager-pss.safewebpss.com.br/service/ApiConfig/config/get",
    aplicacao: "LicitacaoCRCFront",
    token: "b59f6c21ebef01230a8e13060db408401a76054a2f776bf93d07d01a55bc2ccd",
  },
};
